import React, { useEffect, useState } from 'react';
import ExpenseCard from '../Expense Tracker/ExpenseCard';
import ExpenseFormModal from '../Expense Tracker/ExpenseFormModal';
import ExpenseChart from '../Expense Tracker/ExpenseChart';
import ExpenseList from '../Expense Tracker/ExpenseList';
import axiosInstance from '../../API/axiosInstance';
import MonthlySummary from './MonthlySummary';
import './expenses.css'; // Custom CSS for styling
import DownloadAppUI from '../../ui_components/download_app/download_app';
import SiteFooter from '../../ui_components/site_footer/site_footer';

const ExpenseTracker = () => {
    const [expenses, setExpenses] = useState([]);
    const [categories, setCategories] = useState([]);
    const [token, setToken] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [userId, setUserId] = useState('');
    const [budget, setBudget] = useState(10000);

    useEffect(() => {
        const tokenFromStorage = localStorage.getItem('token');
        setToken(tokenFromStorage);

        const storedUser = localStorage.getItem("currentUser");
        if (storedUser) {
            const user = JSON.parse(storedUser);
            setUserId(user.id);
            setBudget(user.budget);
        }
    }, []);

    useEffect(() => {
        if (token && userId) {
            fetchExpenses();
            fetchCategories();
        }
    }, [token, userId]);

    const fetchExpenses = async () => {
        try {
            const res = await axiosInstance.get(`/expense/user/${userId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setExpenses(res.data);
        } catch (err) {
            console.error('Error fetching expenses', err);
        }
    };


    const fetchCategories = async () => {
        try {
            const res = await axiosInstance.get(`/resources/categories`);
            setCategories(res.data);
        } catch (err) {
            console.error('Error fetching categories', err);
        }
    };

    const handleAddExpense = async (expenseData) => {
        try {
            await axiosInstance.post(`/expense`, expenseData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            fetchExpenses();
            setShowModal(false);
        } catch (err) {
            console.error('Error adding expense', err);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axiosInstance.delete(`/expense/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setExpenses((prev) => prev.filter((e) => e.id !== id));
        } catch (err) {
            console.error('Delete error', err);
        }
    };

    return (
        <div className="container my-4 expense-tracker">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                <h2 className="fw-bold">Expense Tracker</h2>
                <button
                    className="btn btn-success px-4"
                    onClick={() => setShowModal(true)}
                >
                    + Add Expense
                </button>
            </div>

            <div className="row mb-4 summary-card">
                <div className="col-md-6 mb-3 mb-md-0 summary-card">
                    <ExpenseCard budget={budget} expenses={expenses} />
                </div>
                <div className="col-md-6 summary-card">
                    <MonthlySummary budget={budget} expenses={expenses} />
                </div>
            </div>



            {/* Chart Full Width */}
            <div className="mb-5">
                <ExpenseChart expenses={expenses} />
            </div>

            {/* All Expenses */}
            <div className="mb-5">
                <ExpenseList expenses={expenses} onDelete={handleDelete} />
            </div>

            {/* Modal */}
            {showModal && (
                <ExpenseFormModal
                    userId={userId}
                    categories={categories}
                    onClose={() => setShowModal(false)}
                    onSubmit={handleAddExpense}
                />
            )}

            <section className="my-5">
                {/* Download the app */}
                <div id='download-app-container' className='m-0'>
                    <DownloadAppUI />
                </div>

                {/* Site Footer */}
                <div>
                    <SiteFooter />
                </div>
            </section>
        </div>
    );
};

export default ExpenseTracker;
